<template>
  <div class="TVChartContainer" ref="chartContainer" />
</template>
<script setup>
import {
  onMounted,
  ref,
  onUnmounted,
  defineProps,
  defineEmits,
  watch,
  computed,
  nextTick,
} from "vue";
// import { widget } from '/charting_library';
// import Datafeed from "./datafeed/datafeed";
// import BitgetDatafeed from "./datafeed/datafeed_bitget";
import { useStore } from "vuex";
import { fetchTradingView } from "@/api/chart/fetchTradingView";
import { useI18n } from "vue-i18n";
import { axiosInstance } from "@/api/baseApi";
const { t, locale } = useI18n({ useScope: "global" });
const store = useStore();
const user_ref_id = computed(
  () => store.state.userInfo.risingUserInfo.user_ref_id
); // login x => 0
const countryCode = ref(null); // 초기값 null로 설정
// const tradingViewParams = {
//     client                 : 'risingx',
//     user                   : user_ref_id.value,
//     chart                  : "1234"
// }

// const {data} = await fetchTradingView(tradingViewParams)

// let layout_content  = null;
// console.log('data',data);

// if(data.value.data) {
//     if(data.value.data.content.length == 0) {
//         layout_content = null;
//     } else {
//         layout_content = JSON.parse(data.value.data.content);
//     }
// }

async function getUserCountryCode() {
  try {
    const res = await axiosInstance.get("user-location-copy", {});
    let result = res.data;
    console.log("user location result", result[0].country);
    return result[0].country || "KR";
  } catch (error) {
    console.log("Error fetching location:", error);

    // 에러 발생 시 브라우저 언어에서 국가 코드 추출
    const browserLang = navigator.language || navigator.userLanguage || "";

    // 언어 태그에서 국가 코드 추출 (예: 'ko-KR' -> 'KR')
    const parts = browserLang.split("-");
    if (parts.length > 1) {
      // 하이픈이 있으면 뒷부분이 국가 코드
      return parts[1].toUpperCase();
    } else {
      // 하이픈이 없으면 언어 코드를 국가 코드로 매핑
      const langCode = parts[0].toLowerCase();
      const languageToCountry = {
        ko: "KR",
        en: "US",
        zh: "CN",
        ja: "JP",
      };
      return languageToCountry[langCode] || "KR";
    }
  }
}
// await getUserCountryCode();

function getLanguageFromURL() {
  const regex = new RegExp("[\\?&]lang=([^&#]*)");
  const results = regex.exec(window.location.search);
  return results === null
    ? null
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}
const emit = defineEmits(["mounted"]);
const props = defineProps({
  ticker: String,
  symbol: {
    default: "Binance:BTC/USDT",
    type: String,
  },
  libraryPath: {
    default: "/charting_library/",
    type: String,
  },
});


const transformTicker = computed(() => {
  if (!countryCode.value) return ""; // countryCode가 아직 로드되지 않았다면 빈 문자열 반환
  const ticker = props.ticker || "BTC"; // props.ticker가 빈 값일 때 "BTC"로 대체
  return countryCode.value === "US" || countryCode.value === "CN"
    ? `bitget:${ticker}/USDT`
    : `Binance:${ticker}/USDT`;
});

// const transformTicker = computed(() => {
//   return `Binance:${props.ticker}/USDT`;
// });

watch(
  () => props.ticker,
  (val) => {
    // console.log('symbol changed',val);
    transformTicker.value =
      countryCode.value === "US" || countryCode.value === "CN"
        ? `bitget:${val}/USDT`
        : `Binance:${val}/USDT`;
    // chartWidget.chart().setSymbol(transformTicker.value);
    // chartWidget.getSavedCharts((callback)=> {
    //   // console.log('get saved charts',callback);
    //   setLastChart(callback)
    // })
    document.body.removeChild(chartingLibraryScript);
    chartingLibraryScript = document.createElement("script");
    chartingLibraryScript.src = "/charting_library/charting_library.js";
    document.body.appendChild(chartingLibraryScript);
    // if (countryCode.value !== "US" && countryCode.value !== "CN") {
    setTV(chartingLibraryScript);
    // console.log("setTV");
    // } else {
    // console.log("Chart not loaded for US or CN users");
    // }
    // setTV(chartingLibraryScript);
  }
);
watch(locale, () => {
  transformTicker.value =
    countryCode.value === "US" || countryCode.value === "CN"
      ? `bitget:${transformTicker.value}/USDT`
      : `Binance:${transformTicker.value}/USDT`;
  document.body.removeChild(chartingLibraryScript);
  chartingLibraryScript = document.createElement("script");
  chartingLibraryScript.src = "/charting_library/charting_library.js";
  document.body.appendChild(chartingLibraryScript);
  // setTV(chartingLibraryScript);
  // if (countryCode.value !== "US" && countryCode.value !== "CN") {
  setTV(chartingLibraryScript);
  // console.log("setTV");
  // } else {
  // console.log("Chart not loaded for US or CN users");
  // }
});

const chartContainer = ref();
let chartWidget;
let chartingLibraryScript = document.createElement("script");
chartingLibraryScript.src = "/charting_library/charting_library.js";
document.body.appendChild(chartingLibraryScript);
onMounted(async () => {
  emit("mounted");
  countryCode.value = await getUserCountryCode(); // 비동기 처리 후 countryCode 값 설정
  // if(countryCode.value !== "US" && countryCode.value !== "CN") {
  // setTV(chartingLibraryScript);
  // console.log('setTV')
  // } else {
  // console.log("Chart not loaded for US or CN users");
  // }
  // setTV(chartingLibraryScript);

  loadChartingLibrary()
    .then((script) => {
      setTV(script); // chartingLibraryScript를 그대로 넘김
    })
    .catch((error) => {
      console.error("Charting Library 로드 실패", error);
    });
});

function loadChartingLibrary() {
  return new Promise((resolve, reject) => {
    if (
      document.querySelector(
        "script[src='/charting_library/charting_library.js']"
      )
    ) {
      resolve(
        document.querySelector(
          "script[src='/charting_library/charting_library.js']"
        )
      );
      return;
    }

    chartingLibraryScript = document.createElement("script");
    chartingLibraryScript.src = "/charting_library/charting_library.js";
    chartingLibraryScript.onload = () => resolve(chartingLibraryScript);
    chartingLibraryScript.onerror = reject;
    document.body.appendChild(chartingLibraryScript);
  });
}

onUnmounted(() => {
  if (chartWidget !== null) {
    chartWidget?.remove();
    chartWidget = null;
  }
});

const waitForTradingView = async () => {
  while (!window.TradingView) {
    await new Promise((resolve) => setTimeout(resolve, 100)); // 100ms 대기
  }
};

const setTV = async (chartingLibraryScript) => {

  await waitForTradingView(); // TradingView 로드 대기

  // chartingLibraryScript.onload = async function () {

  // countryCode.value = await getUserCountryCode();
  let DatafeedModule;
  if (["US", "CN"].includes(countryCode.value)) {
    DatafeedModule = async () => await import("./datafeed/datafeed_bitget");
  } else if (["JP"].includes(countryCode.value)) {
    DatafeedModule = async () => await import("./datafeed/datafeed_jp");
  } else {
    DatafeedModule = async () => await import("./datafeed/datafeed");
  }

  const datafeed = await DatafeedModule();

  await nextTick();
  // const datafeed =
  //   countryCode === "US" || countryCode === "CN" ? BitgetDatafeed : Datafeed;

  const widgetOptions = {
    // saved_data : layout_content,
    debug: false,
    symbol: transformTicker.value,
    datafeed: datafeed.default,
    interval: "1h",
    container: chartContainer.value,
    library_path: props.libraryPath,
    locale: locale.value,
    disabled_features: ["use_localstorage_for_settings"],
    enabled_features: [
      "create_volume_indicator_by_default",
      "header_saveload",
      "study_templates",
    ],
    charts_storage_url: process.env.VUE_APP_TVCHART_URL,
    charts_storage_api_version: "v1",
    client_id: "risingx",
    user_id: user_ref_id.value,
    auto_save_delay: 3,
    fullscreen: false,
    autosize: true,
    theme: "Dark",
    time_frames: [],
    load_last_chart: false,
    // studies_overrides: props.studiesOverrides,
  };
  chartWidget = new window.TradingView.widget(widgetOptions);
  chartWidget.onChartReady(function () {
    // console.log('user_ref_id',user_ref_id.value);
    if (user_ref_id.value != "0" && user_ref_id.value != undefined) {
      chartWidget.getSavedCharts(async (callback) => {
        // console.log('get saved charts',callback);
        await setLastChart(callback);
      });
      chartWidget.headerReady().then(() => {
        // console.log('chart header ready');
        chartWidget.subscribe("onAutoSaveNeeded", () => {
          chartWidget.saveChartToServer(
            () => {
              console.log("onComplete");
            },
            () => {
              console.log("onFail");
            },
            {
              chartName: transformTicker.value,
              defaultChartName: transformTicker.value,
            }
          );
        });
      });
    }
    chartWidget.applyOverrides({
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, // 타임존 클라이언트에 따라 변동
      locale: locale.value,
    });
  });
  // };
};

const setLastChart = (list) => {
  chartWidget.chart().setSymbol(transformTicker.value);
  let loadList = [];
  loadList.push(...list);
  const filterByEx = loadList.filter(
    (item) => item.name.split(":")[0] === "Binance"
  );
  // console.log('filterByEx',filterByEx);
  const filteredByName = filterByEx.filter(
    (item) => item.name === transformTicker.value
  );
  // console.log('transformTicker.value',transformTicker.value,'Filtered List:', filteredByName);
  // 필터링된 객체들 중 id가 가장 큰 객체 찾기
  if (filteredByName.length > 0) {
    const maxIdItem = filteredByName.reduce((prev, current) => {
      return prev.id > current.id ? prev : current;
    });
    // console.log('ID가 가장 큰 객체:', maxIdItem);
    chartWidget.loadChartFromServer(maxIdItem); // 불러올 차트 object 넣기
  } else {
    // console.log('일치하는 객체가 없습니다.');
  }
};
</script>

<style scoped>
.TVChartContainer {
  height: 650px;
}
@media screen and (max-width: 768px) {
  .TVChartContainer {
    height: 450px;
  }
}
</style>
